export function strContains(str = '', search = '', regex = false) {
	if (!regex) {
		return str?.indexOf(search) > -1;
	}

	// check if /i flag is used in searchstring and convert to proper pattern. Strip extra \ from mongo
	const findFlag = search.replace(/\\/g, '').split('/');

	if (findFlag[findFlag.length - 1] === 'i') {
		//to be sure, strip first '/' from searchpattern if used for flag
		const extractSearch = findFlag[0] === '' ? findFlag.slice(1, -1).join('/') : findFlag.slice(0, -1).join('/');

		const fixedRegex = new RegExp(extractSearch, 'i');

		return fixedRegex.test(str);
	}
	return new RegExp(search).test(str);
}

export function getCookie(cookieKey = '') {
	for (let cookie of document.cookie.split('; ')) {
		let [key, val] = cookie.split('=');
		if (cookieKey === key) {
			return decodeURIComponent(val);
		}
	}
	return;
}

function rootDomain() {
	const parts = window.location.hostname.split('.');
	if (parts.length <= 2) {
		return window.location.hostname;
	}

	const sliced = parts.slice(-3);
	if (['co', 'com'].indexOf(sliced[1]) > -1) return sliced.join('.');

	return sliced.slice(-2).join('.');
}

export function setCookie(name, value, days) {
	let expires = '';
	if (days) {
		let date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = `; expires=${date.toUTCString()}`;
	}
	const secure = document.location.protocol === 'https:' ? '; Secure' : '';
	const cookie = `${name}=${value || ''}${expires};domain=.${rootDomain()};path=/${secure};`;
	document.cookie = cookie;
}

export function _get(value, path, defaultValue, ignoreWindow = true) {
	return String(path)
		.replace(/\["|\['|\[/g, '.')
		.replace(/"]|']|]/g, '')
		.split('.')
		.reduce((acc, current, index, currentArr) => {
			if (index === 0 && current === 'window' && ignoreWindow) {
				return acc;
			}

			try {
				const key = current.replace(/[()]/g, ''); //handle possible functions

				const wildcard = key === '*';
				const lastWildcard = key === '*LAST';

				if ((wildcard || lastWildcard) && Array.isArray(acc)) {
					const nextSearchKey = currentArr[index + 1];
					acc = acc.filter(item => {
						return item?.[nextSearchKey];
					});

					return wildcard ? acc[0] ?? defaultValue : acc.pop() ?? defaultValue;
				} else {
					acc = typeof acc[key] === 'function' ? acc[key]() : acc[key];
					return acc ?? defaultValue;
				}
			} catch (e) {
				return defaultValue;
			}
		}, value);
}

export function appendScript({ src, id = 'mopinionFeedbackScript', onLoad = () => {} }) {
	const script = document.createElement('script');
	script.async = 'async';
	script.id = id;
	script.src = src;
	script.onload = script.onreadystatechange = () => {
		if (!script.readyState || script.readyState === 'loaded' || script.readyState === 'complete') {
			try {
				onLoad();
			} catch (e) {}
		}
	};
	document.head.appendChild(script);
}

export function debounce(fn, delay = 0) {
	let timerId;
	return function (...args) {
		if (timerId) {
			clearTimeout(timerId);
		}
		timerId = setTimeout(() => {
			fn(...args);
			timerId = null;
		}, delay);
	};
}

export function flattenArray(array = []) {
	return array.reduce((acc, item) => acc.concat(item), []);
}

export function setRecursiveTimeout(callback, delay = 0) {
	let timeoutId;
	let canceled = false;

	const recursiveFn = () => {
		if (canceled) {
			return;
		}

		requestAnimationFrame(() => {
			callback();
			timeoutId = setTimeout(recursiveFn, delay);
		});
	};

	recursiveFn();

	const cancel = () => {
		canceled = true;
		clearTimeout(timeoutId);
	};

	return cancel;
}

export function schedule(fn, delay = 0) {
	requestAnimationFrame(() => {
		setTimeout(fn, delay);
	});
}

export function timeInSeconds() {
	return Math.floor(Date.now() / 1000);
}
